export type Retrieve = 'corppass' | 'manual';
export const Retrieve: Record<Retrieve, Retrieve> = {
  corppass: 'corppass',
  manual: 'manual',
} as const;

export type Method = Retrieve | 'populate';
export const Method: Record<Method, Method> = {
  corppass: 'corppass',
  manual: 'manual',
  populate: 'populate',
} as const;
